import request from '../../axios';
import {IPostCreditOrderTransactionPayload} from '../postCreateCreditOrderTransaction/postCreateCreditOrderTransaction';

const postCreateCashBackOrderTransaction = async (
  payload: IPostCreditOrderTransactionPayload,
) => {
  const data = await request.post(
    `api/v2/payment/create-order-transaction-with-cashback`,
    payload,
  );

  return data;
};

export default postCreateCashBackOrderTransaction;
